export default __webpack_public_path__ + "static/media/bloodforaid2.caa5ea25.png";